import { createAction } from "../creators";

export default {
  ...createAction("APPLY_JOB", "payload"),
  ...createAction("APPLY_JOB_DONE", "data"),

  ...createAction("GET_RELATED_CAREERS", "payload"),
  ...createAction("GET_RELATED_CAREERS_DONE", "data"),
};
